import { FormReviewData } from "@/types";

interface ActionButtonsProps {
  formData: FormReviewData;
  isViewMode: boolean;
  isInIframe: boolean;
  processing: boolean;
  showQuickNote: boolean;
  onApprove: () => void;
  onFlag: () => void;
  onQuickNote: () => void;
  onDetailedNote: () => void;
  onPrint: () => void;
  onPrintMedications: () => void;
  onBack: () => void;
}

export function ActionButtons({
  formData,
  isViewMode,
  isInIframe,
  processing,
  showQuickNote,
  onApprove,
  onFlag,
  onQuickNote,
  onDetailedNote,
  onPrint,
  onPrintMedications,
  onBack,
}: ActionButtonsProps) {
  const isCompleted =
    formData.formStatus === "complete" || formData.formStatus === "completed";

  return (
    <div className="review-actions-top">
      {!isViewMode && (
        <>
          <button
            className="action-button approve-button"
            onClick={onApprove}
            disabled={processing || isCompleted}
            title={
              isCompleted
                ? "This form has already been approved"
                : "Approve and complete this form"
            }
          >
            ✓ {isCompleted ? "Already Approved" : "Approve Form"}
          </button>
          <button
            className="action-button note-button"
            onClick={onDetailedNote}
            disabled={processing}
          >
            + Add Note
          </button>
          {/* <button
            className="action-button flag-button"
            onClick={onFlag}
            disabled={processing}
            title="Flag this form for review"
          >
            🚩 Flag Form
          </button> */}
        </>
      )}
      <button
        className="action-button print-button"
        onClick={onPrint}
        disabled={processing}
        title="Print consultation information"
      >
        Print
      </button>
      <button
        className="action-button print-button"
        onClick={onPrintMedications}
        disabled={processing}
        title="Print medication prescription form"
        style={{ backgroundColor: "#f59e0b", borderColor: "#f59e0b" }}
      >
        Prescription Print
      </button>
      {/* <button className="action-button back-button" onClick={onBack}>
        ← {isInIframe ? "Close Review" : "Back to Dashboard"}
      </button> */}
    </div>
  );
}
